import axios, {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse} from '../../../../shared/models/ApiModels'
import {ICorporateModel} from '../../admin/corporate/CorporateModel'
import {ICompanyProfileRequest} from './CompanyProfileModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

/** Oturumdaki kullanıcının firması (gateway) */
const PROFILE_URL = `${API_URL}api/v1/corporate/profile`
/** Görseller MinIO'ya eywaik-service üzerinden yüklenir */
const DOCUMENT_UPLOAD_URL = `${API_URL}api/v1/document/upload`

export type ImageCategory = 'LOGO' | 'HEADER'

export function getCompanyProfile(): Promise<AxiosResponse<ApiResponse<ICorporateModel>>> {
  return axios.get(PROFILE_URL)
}

export function updateCompanyProfile(
  request: ICompanyProfileRequest
): Promise<AxiosResponse<ApiResponse<ICorporateModel>>> {
  return axios.patch(PROFILE_URL, request)
}

export function uploadCompanyImage(
  file: File,
  category: ImageCategory
): Promise<AxiosResponse<ApiResponse<{id: string}>>> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('category', category)
  return corporateApi.post(DOCUMENT_UPLOAD_URL, formData)
}
